import useRequestTable from 'app/hooks/useRequestTable'

import {
    RequestKeys,
} from 'app/hooks/useRequest'

import {
    LaneFee,
} from 'app/Apps/Pricing/Pricing.types'
import requests from 'app/requests/ContractBasis/LaneGroup/LaneGroup.requests'

export default (laneGroupId, showArchived) => {
    return useRequestTable<LaneFee>({
        key: RequestKeys.getLaneByLaneGroup,
        params: {
            laneGroupId,
        },
        config: requests.getLaneByLaneGroup,
        showArchived,
        keepPreviousData: true,
    })
}
